export const LocationModalType = {
    addLocation: 'AddLocation',
    addPinDrop: 'AddPinDrop',
    editPinDrop: 'EditPinDrop',
};
